/**
 * Hai quyền của kênh WEBSITE mà bảng so sánh gói chưa từng nói tới (#19596).
 *
 * <p><b>Vì sao cần.</b> QA (09/10) không đọc được từ bảng so sánh rằng tên miền riêng và việc tự
 * sắp xếp khối trang chủ có ở gói nào — bảng chỉ ghi "Kênh số: Website · Zalo Mini App" cho cả hai
 * gói. Phòng khám vì thế không biết mình đang mua gì.
 *
 * <p><b>Đây là quyền ĐANG CÓ THẬT, không phải lời hứa mới.</b> Cả hai do Addy Sites chặn theo
 * `tenants.isPro`:
 * <ul>
 *   <li>tên miền riêng — `customDomainWrite.ts`: "Tên miền riêng chỉ dùng được với gói Pro.";
 *   <li>sắp xếp khối trang chủ — `themeStudio.ts` gọi `blockPlanViolation(current, blocks, isPro)`.
 * </ul>
 *
 * <p>Và `isPro` do HIS đẩy sang, tính bằng {@code WebsitePublishedOutboxConfig.isPaidPlan}: giá
 * NIÊM YẾT của gói &gt; 0, và phòng khám không ở trạng thái chỉ-đọc. Nên câu trả lời cho từng gói
 * suy ra được từ chính giá niêm yết mà bảng đang hiển thị — không cần thêm dữ liệu, không cần thêm
 * API, và không thể lệch với thứ Addy Sites thực sự chặn.
 *
 * <p><b>Điều cố ý KHÔNG làm:</b> không thêm một cờ entitlement mới cho hai quyền này. Thêm một
 * nguồn thứ hai cho câu hỏi mà `isPro` đã trả lời là đúng lớp lỗi vé này mở ra để đóng.
 */
export const WEBSITE_PAID_ENTITLEMENTS: readonly { label: string; note: string }[] = [
  {
    label: "Tên miền riêng cho website",
    note: "Gói có phí",
  },
  {
    label: "Tự sắp xếp khối trang chủ website",
    note: "Gói có phí",
  },
];

/**
 * Gói này có hai quyền trên không — theo đúng luật {@code isPaidPlan}: giá niêm yết &gt; 0.
 *
 * <p>Trạng thái chỉ-đọc KHÔNG tính ở đây: nó là trạng thái THANH TOÁN của một phòng khám, không
 * phải thuộc tính của một gói, và bảng này so sánh các gói. Nói ra ở chú thích của bảng thì đúng
 * chỗ hơn là bịa một cột.
 */
export function websiteEntitlementsIncluded(listPriceVnd: number): boolean {
  return listPriceVnd > 0;
}
